import React from 'react'
import { Container } from 'react-bootstrap';
import { GiHealing } from 'react-icons/gi';
import { SiOxygen } from 'react-icons/si';
import { BiHealth } from 'react-icons/bi';


export default function FactsCoffees() {
    return (
        <section className="py-4">
            <Container>
                <div className="facts-cont">
                    <h2 className="fs-3 mb-4 fw-bold make-serif text-center secondary-text"><span className="fw-light make-serif">Facts about </span>Coffee</h2>
                    <div className="facts-cards mt-3 shadow text-center">
                        <div className="light-gradient">
                            <GiHealing size="3.5rem" className="center-item main-lime-text"  />
                            <h5 className="fw-medium d-inline-block secondary-text my-3">Boost Energy</h5>
                            <p className="secondary-text small-text-02">Coffee conatains coffeine, a stimulant that has been shown to increase energy levels.</p>
                        </div>
                        <div className="main-background">
                            <BiHealth size="3.5rem" className="center-item main-lime-text"  />
                            <h5 className="fw-medium d-inline-block white-text my-3">Lowers Diabetes</h5>
                            <p className="white-text small-text-02">Regular coffee can result in the lowering type 2 Diabetes over a long term.</p>
                        </div>
                        <div className="light-gradient">
                            <SiOxygen size="3.5rem" className="center-item main-lime-text"  />
                            <h5 className="fw-medium d-inline-block secondary-text my-3">Antioxidants</h5>
                            <p className="secondary-text small-text-02">Coffee contains an antioxidant called chlorogeric acid which helps lowers cholesterol.</p>
                        </div>
                    </div>
                </div>
            </Container>
  
        </section>
    )
}
